import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import ImagePicker from '../../../components/ImagePicker/ImagePicker';
import ImagePlaceholder from '../../../assets/images/image_blank.png';
import Card from '../../../components/Card/Card';

const cardBodyClassName = 'px-[30px] pb-[30px]';
const cardContainerClassName = 'flex-none mb-[40px]';
const imagePickerClassName = 'w-full h-[200px]';

const ArticlesBanner = ({ bannerImage, setFieldValue }) => {
  const [userImage, setUserImage] = useState(bannerImage);

  useEffect(() => {
    setUserImage(bannerImage);
  }, [bannerImage]);

  const onImageChange = ({ target }) => {
    const url = URL.createObjectURL(target.files[0]);
    setUserImage(url);
    setFieldValue('bannerImage', url);
    setFieldValue('bannerImageFile', target.files[0]);
  };

  return (
    <Card
      headerTitle="Banner"
      showHeader
      styleBodyContainer={cardBodyClassName}
      headerBordered={false}
      styleContainer={cardContainerClassName}
      required
    >
      <ImagePicker
        defaultImage={userImage || ImagePlaceholder}
        styleImageContainer={imagePickerClassName}
        onImageChange={onImageChange}
        name="bannerImage"
      />
    </Card>
  );
};

ArticlesBanner.propTypes = {
  bannerImage: PropTypes.string,
  setFieldValue: PropTypes.func
};

ArticlesBanner.defaultProps = {
  bannerImage: null,
  setFieldValue: () => {}
};

export default ArticlesBanner;
